import React from 'react';
import { capabilities } from '../data/products';

const SharedFoundation = () => (
    <section id="technology" aria-labelledby="technology-title" className="scroll-mt-24 mx-auto max-w-screen-2xl px-5 sm:px-8 lg:px-12 py-16">
        <div className="mx-auto max-w-3xl text-center">
            <h2 id="technology-title" className="text-3xl font-bold text-blue-900">Shared AI capabilities. Purpose-built applications.</h2>
            <p className="mt-5 text-lg leading-relaxed text-gray-600">Our work connects speech, visual understanding, knowledge, and software tools. We combine these capabilities around each application's audience, data, and review needs.</p>
        </div>
        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {capabilities.map((capability, index) => (
                <article key={capability.id} className="border-t-4 border-blue-900 pt-5">
                    <p className="text-sm font-semibold text-teal-700" aria-hidden="true">0{index + 1}</p>
                    <h3 className="mt-2 text-xl font-bold text-blue-900">{capability.title}</h3>
                    <p className="mt-3 text-base leading-relaxed text-gray-600">{capability.description}</p>
                </article>
            ))}
        </div>
        <p className="mx-auto mt-10 max-w-3xl text-center text-base leading-relaxed text-gray-600">A spoken assessment, a dubbed video, and a clinic conversation all involve understanding language and producing a useful response. Medical imaging and visual learning apply image understanding to different specialist workflows.</p>
    </section>
);
export default SharedFoundation;
